/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalBillingProfileAddress
 */
export interface AdditionalBillingProfileAddress {
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    street2?: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    formattedAddress: string;
    /**
     * 
     * @type {string}
     * @memberof AdditionalBillingProfileAddress
     */
    region?: string;
}

/**
 * Check if a given object implements the AdditionalBillingProfileAddress interface.
 */
export function instanceOfAdditionalBillingProfileAddress(value: object): value is AdditionalBillingProfileAddress {
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('formattedAddress' in value) || value['formattedAddress'] === undefined) return false;
    return true;
}

export function AdditionalBillingProfileAddressFromJSON(json: any): AdditionalBillingProfileAddress {
    return AdditionalBillingProfileAddressFromJSONTyped(json, false);
}

export function AdditionalBillingProfileAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalBillingProfileAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'street': json['street'],
        'street2': json['street2'] == null ? undefined : json['street2'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'countryCode': json['countryCode'],
        'formattedAddress': json['formattedAddress'],
        'region': json['region'] == null ? undefined : json['region'],
    };
}

export function AdditionalBillingProfileAddressToJSON(value?: AdditionalBillingProfileAddress | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'street': value['street'],
        'street2': value['street2'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'countryCode': value['countryCode'],
        'formattedAddress': value['formattedAddress'],
        'region': value['region'],
    };
}

